<template>
    <div class="contentHome">
        <div class="centerPage">
            <tabCommon></tabCommon>
            <div class="right">
                <div class="title flex">
                    <span>专家会议</span>
                    <div class="btnTab">
                        <el-button size="mini" @click="changeStatus(0,-1)" :class="active==0?'activeIndex':''">全部({{count.all}})</el-button>
                        <el-button size="mini" @click="changeStatus(1,0)" :class="active==1?'activeIndex':''">待开始({{count.s0}})</el-button>
                        <el-button size="mini" @click="changeStatus(2,1)" :class="active==2?'activeIndex':''">会诊中({{count.s1}})</el-button>
                        <el-button size="mini" @click="changeStatus(3,2)" :class="active==3?'activeIndex':''">已结束({{count.s2}})</el-button>
                    </div>
                </div>
                <div class="formUserInfo">
                    <div class="cnHomeTabsItem flex"
                         v-for="(obj,index) in page.rows"
                         :key="index">
                        <div class="avatar img" :style="'backgroundImage: url('+obj.thumbnailPath+')'"></div>
                        <div class="rightHome">
                            <h2 class="overflow">{{obj.title}}</h2>
                            <p class="overflow">{{obj.subTitle}}</p>
                            <div class="flex">
                                <span :class="obj.state==0?'yellow':obj.state==1?'green':'cost'">{{obj| stateFmt}}</span>
                                <el-button size="mini" class="solid" @click="toConsultationDetail(obj.id)">查看详情</el-button>
                            </div>

                        </div>
                    </div>
                    <div class="empty" v-if="page.rows.length==0">
                        <img src="../../assets/img/no.png" alt="" width="200">
                        <p>这里什么都没有</p>
                    </div>
                    <el-pagination
                            class="pagination"
                            background
                            prev-text="Prev"
                            next-text="Next"
                            @current-change="skipPage"
                            :current-page="page.current"
                            :page-size="page.size"
                            layout="prev, pager, next"
                            :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import base from '@/api/common';
    export default {
        name: "expertCon",
        data() {
            return {
                active: 0,
                // 当前页

                count:{
                    all: 0,
                    s0: 0,
                    s1: 0,
                    s2: 0
                },
                page: {
                    url: base.api.expert.consultation.list_me, //默认全部内容
                    current: 1,
                    size: 5,
                    total: 4,
                    rows: [],
                    status : -1,
                }
            }
        },
        components: {
            'tabCommon': () => import('./tabCommon'),
        },
        mounted() {
            this.$ajax.get(base.api.expert.consultation.count).then((res)=>{
                if (res.data.status === 'success'){
                    this.count = res.data.data;
                }
            });
            this.getData();
        },
        methods: {
            toDetail() {
                this.$router.push({name: 'phyDetail'})
            },
            toConsultationDetail(id,state){
                this.$router.push({name: 'consultationDetail',query:{id:id,state:state}});
            },
            // 当前页
            skipPage(current) {
                this.page.current = current;
                this.getData();
            },
            changeStatus(index,status){
                this.active = index;
                this.page.status = status;
                this.page.current = 1;
                this.getData();
            },
            getData(){
                if(this.page.url){
                    this.$ajax.get(this.page.url,{params:{
                        page: this.page.current,
                        size: this.page.size,
                        status: this.page.status
                    }}).then((res)=>{
                        if(res.data.status === 'success'){
                            this.page.rows = res.data.rows;
                        }
                    })
                }
            },
        },
        filters:{
            stateFmt(item){
                if (item) {
                    //item
                    let s = new Date(item.meetStartDate.replace(/-/g, "/"));
                    let e = new Date(item.meetEndDate.replace(/-/g, "/"));
                    let cur = new Date();

                    if (e.getTime() <= cur.getTime()) {
                        item.state = 3;
                        return "已结束";
                    }
                    if (s.getTime() > cur.getTime()) {
                        item.state = 0;
                        return "待开始";
                    }
                    if (s.getTime() <= cur.getTime() && e.getTime() >= cur.getTime()) {
                        item.state = 1;
                        return "会诊中";
                    }
                    return "-";
                }
                return "已结束";
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/css/personalCenter.scss";

    .cnHomeTabsItem {
        .avatar {
            width: 267px;
            height: 100px;
        }

        .rightHome {
            width: calc(100% - 287px);

            h2 {
                height: 39px;
            }

            p {
                height: 26px;
            }
        }
    }
</style>
